import styled from 'styled-components';
import {TextButtonBase} from '../../atoms/TextButton';
import {ShadowColor} from '../../Colors';

export default{
	Wrapper : styled.div`
        position: relative;
        display: inline-block;
    `,
	Button : styled(TextButtonBase)`
    `,
	Content : styled.div`
        position : absolute;
        box-shadow: 0px 8px 16px 0px ${ShadowColor};
        z-index: 1;
        ${({ right }) => right && `
			right : ${right};
		`}
        ${({ left }) => left && `
			left : ${left};
		`}
    `,
	MenuItem : styled.div`
        display : block;
    `
};